import React from 'react';
import * as stylex from '@stylexjs/stylex';
import Table from "nood-comp/src/comp/data/table/Table";
import { queryStringMod } from "nood-comp/src/util/converters/converters";
import ElapsedTime from "nood-comp/src/util/date/ElapsedTime";
export default function AnalyticsSearchLog(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    paging: {
      per_page: 10,
      sorters: [{
        property: 'created_dt',
        isAsc: false
      }]
    },
    data_source: "/search-logs",
    rowPadding: 5,
    cols: [{
      property: "keyword",
      label: "Search Phrase",
      to: function to(obj, idx) {
        return queryStringMod({
          'do': "view",
          'id': obj.id
        });
      },
      filterType: "text",
      icon: "search"
    }, {
      property: "user_role",
      label: "User Role",
      icon: "user",
      filterTextfieldWidth: 100
    }, {
      property: "form_id",
      label: "Form ID",
      filterType: "text",
      icon: "tag"
    }, {
      content: function content(obj, idx) {
        return /*#__PURE__*/React.createElement(ElapsedTime, {
          key: "an-src-".concat(obj.id),
          datetime: obj.created_dt
        });
      },
      width: 50
    }]
  }));
}

// @ts-ignore